import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const LoginUtilities = ({ rememberMe, onRememberMeChange, onForgotPassword }) => {
  return (
    <div className="flex items-center justify-between">
      <Checkbox
        label="Remember me"
        checked={rememberMe}
        onChange={(e) => onRememberMeChange(e?.target?.checked)}
        size="sm"
      />
      <Button
        variant="link"
        size="sm"
        onClick={onForgotPassword}
        className="text-primary hover:text-primary/80 p-0 h-auto"
      >
        Forgot password?
      </Button>
    </div>
  );
};

export default LoginUtilities;